var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7124 7.98678C8.7124 7.08843 8.7124 6.63926 8.91626 6.39166C9.09386 6.17595 9.36532 6.04247 9.65917 6.02635C9.99648 6.00785 10.4032 6.257 11.2168 6.75531L21.8036 13.24C22.4758 13.6518 22.8119 13.8577 22.929 14.1172C23.0314 14.344 23.0314 14.599 22.929 14.8259C22.8119 15.0853 22.4758 15.2912 21.8036 15.703L11.2168 22.1877C10.4032 22.686 9.99648 22.9352 9.65917 22.9167C9.36532 22.9005 9.09386 22.7671 8.91626 22.5514C8.7124 22.3038 8.7124 21.8546 8.7124 20.9562V7.98678Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.00556,
    y: 1.9206,
    width: 25.1045,
    height: 25.1045,
    rx: 4.36599,
    stroke: "currentColor",
    strokeWidth: 2.183
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/icon_video.32d8facf.svg";
export { ForwardRef as ReactComponent };